import { render, staticRenderFns } from "./SidebarAdminGroup.vue?vue&type=template&id=23e80b23&scoped=true"
import script from "./SidebarAdminGroup.vue?vue&type=script&lang=js"
export * from "./SidebarAdminGroup.vue?vue&type=script&lang=js"
import style0 from "./SidebarAdminGroup.vue?vue&type=style&index=0&id=23e80b23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e80b23",
  null
  
)

export default component.exports